import errorManager from '@/rollbar.js';

const setObserver = () => {
  document.querySelector('#range_e_user_modal .btn-success').addEventListener('click', (e) => {
    let fromDate = $('#range_user_modal_pivot_from').datepicker('getDate');
    let toDate = $('#range_user_modal_pivot_to').datepicker('getDate');

    // Calcolo la differenza in mesi
    let monthDiff = (toDate.getFullYear() - fromDate.getFullYear()) * 12 + (toDate.getMonth() - fromDate.getMonth());

    if (monthDiff > 6) {
      alert('Selezionare un periodo massimo di sei mesi.');
      e.preventDefault();
    }
  });
};

const init = () => {
  try {
    setObserver();
  } catch (e) {
    errorManager(e);
  }
};

window.validationRangeAndUserModal = {
  init,
};
